import React from "react";

function MainImg() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            fill="none"
            viewBox="0 0 400 403"
        >
            <g clipPath="url(#clip0_0_6484)">
                <path
                    fill="url(#paint0_linear_0_6484)"
                    d="M189.053 284.649S156.261 108.098 75.162 8.669c-5.455-6.683-16.14-4.736-18.83 3.454C38.366 66.897.836 233.881 189.052 284.65z"
                ></path>
                <path
                    fill="#fff"
                    d="M172.193 272.541c.406.439-.194 1.067-.654.691-17.006-13.979-82.077-81.741-100.936-211.331-.063-.416.556-.541.648-.135 7.1 30.175 36.717 141.602 100.942 210.775z"
                    opacity="0.5"
                ></path>
                <path
                    fill="url(#paint1_linear_0_6484)"
                    d="M94.785 400.135h-21.37V106.083c0-17.757 14.47-32.204 32.254-32.204h22.233c6.001 0 10.884-4.875 10.884-10.867V1.276h21.371v61.736c0 17.757-14.47 32.204-32.255 32.204h-22.233c-6 0-10.884 4.876-10.884 10.867v294.052z"
                ></path>
                <path
                    fill="url(#paint2_linear_0_6484)"
                    d="M163.622 53.716h-28.476v4.865h28.476v-4.865z"
                ></path>
                <path
                    fill="url(#paint3_linear_0_6484)"
                    d="M112.832 70.105v28.43h4.873v-28.43h-4.873z"
                ></path>
                <path
                    fill="url(#paint4_linear_0_6484)"
                    d="M69.737 120.313h28.475v-4.865H69.737v4.865z"
                ></path>
                <path
                    fill="url(#paint5_linear_0_6484)"
                    d="M142.212 340.443S112.614 191.68 43.047 108.567c-4.675-5.586-13.686-3.827-15.864 3.121C12.597 158.147-17.3 299.585 142.212 340.443z"
                ></path>
                <path
                    fill="#fff"
                    d="M127.844 330.397c.348.367-.15.904-.542.59-14.514-11.621-70.201-68.158-87.526-177.411-.059-.353.464-.464.546-.121 6.32 25.41 32.536 119.206 87.522 176.942z"
                    opacity="0.5"
                ></path>
                <path
                    fill="#7D97F4"
                    d="M34.767 316.206l-12.748-1.019c-10.97 0-19.865-8.881-19.865-19.835v-61.084h25.58l7.033 81.938z"
                ></path>
                <path
                    fill="#91B3FA"
                    d="M29.68 236.111l1.184-.075a1.749 1.749 0 011.853 1.632l4.548 72.175-5.303.333-4.508-71.543a2.377 2.377 0 012.227-2.522z"
                ></path>
                <path
                    fill="#7D97F4"
                    d="M69.36 350.092L14.13 329.861c6.887 10.036 10.69 30.097 14.02 51.701l-7.012 16.375a1.476 1.476 0 001.422 1.875h39.137c.973 0 1.68-.918 1.428-1.856l-5.396-12.215a18.231 18.231 0 01-1.287-10.548c1.756-9.828 5.628-18.438 12.916-25.096v-.005z"
                ></path>
                <path
                    fill="#7D97F4"
                    d="M6 315.153a1.16 1.16 0 00-.991 1.73c12.834 22.835 32.705 33.789 56.534 33.789 23.83 0 43.41-15.999 44.247-35.993a1.166 1.166 0 00-1.18-1.213L6 315.153z"
                ></path>
                <path
                    fill="#91B3FA"
                    d="M31.611 306.702h70.279c3.644 0 6.601 2.952 6.601 6.591v1.894H37.69c-3.354 0-6.079-2.721-6.079-6.069v-2.416z"
                ></path>
                <path
                    fill="#7D97F4"
                    d="M27.701 231.673H2.333A2.331 2.331 0 000 234.002v1.338a2.331 2.331 0 002.333 2.329H27.7a2.33 2.33 0 002.333-2.329v-1.338a2.33 2.33 0 00-2.333-2.329z"
                ></path>
                <path
                    fill="url(#paint6_linear_0_6484)"
                    d="M120.294 141.409c-5.047.246-8.914 4.581-8.57 9.615l15.747 232.388c.32 4.731 4.259 8.408 9.011 8.408h168.273a9.023 9.023 0 008.996-8.248l19.953-232.562c.431-5.04-3.368-9.442-8.425-9.77-62.526-4.02-131.614-3.431-204.985.164v.005z"
                ></path>
                <path
                    fill="#91B3FA"
                    d="M126.857 204.325c-.712-8.35 5.88-15.52 14.271-15.52h160.68c8.367 0 14.954 7.131 14.276 15.457l-11.707 144.115c-.6 7.402-6.775 13.113-14.213 13.147l-136.623.604c-7.462.034-13.705-5.663-14.339-13.089L126.847 204.32l.01.005z"
                ></path>
                <path
                    fill="#7D97F4"
                    d="M321.025 180.518a1.81 1.81 0 01-1.481.773H121.553c-.76 0-1.438-.473-1.694-1.189a1.798 1.798 0 011.694-2.411h197.991c1.457 0 2.309 1.634 1.481 2.827z"
                ></path>
                <path
                    fill="url(#paint7_linear_0_6484)"
                    d="M124.993 149.159a1.839 1.839 0 00-1.79 1.967l1.442 19.767a1.836 1.836 0 001.829 1.701h42.578c.992 0 1.805-.788 1.834-1.778l.653-20.797a1.831 1.831 0 00-1.878-1.889l-44.672 1.029h.004z"
                ></path>
                <path
                    fill="url(#paint8_linear_0_6484)"
                    d="M256.017 157.861l.764 13.032a1.836 1.836 0 001.83 1.701h54.424c.992 0 1.805-.788 1.834-1.778l1.331-14.061a1.831 1.831 0 00-1.878-1.889l-56.52 1.029a1.838 1.838 0 00-1.79 1.966h.005z"
                ></path>
                <path
                    fill="#BDD0FB"
                    d="M196.646 172.594c6.663 0 12.065-5.393 12.065-12.046s-5.402-12.046-12.065-12.046c-6.663 0-12.064 5.393-12.064 12.046s5.401 12.046 12.064 12.046z"
                ></path>
                <path
                    fill="#fff"
                    d="M206.219 161.261c1.087-4.597-1.765-9.203-6.369-10.288-4.604-1.085-9.218 1.762-10.304 6.359-1.087 4.597 1.765 9.203 6.369 10.288 4.604 1.085 9.217-1.762 10.304-6.359z"
                    opacity="0.64"
                ></path>
                <path
                    fill="#BDD0FB"
                    d="M231.132 172.594c6.663 0 12.065-5.393 12.065-12.046s-5.402-12.046-12.065-12.046c-6.663 0-12.064 5.393-12.064 12.046s5.401 12.046 12.064 12.046z"
                ></path>
                <path
                    fill="#fff"
                    d="M240.845 160.682c.758-4.663-2.413-9.056-7.083-9.813-4.67-.756-9.07 2.41-9.828 7.072-.758 4.662 2.413 9.055 7.083 9.812 4.67.757 9.07-2.409 9.828-7.071z"
                    opacity="0.64"
                ></path>
                <path
                    fill="#BDD0FB"
                    d="M267.868 147.169h-10.83c-.567 0-1.026.458-1.026 1.024v3.397c0 .566.459 1.024 1.026 1.024h10.83c.567 0 1.026-.458 1.026-1.024v-3.397c0-.566-.459-1.024-1.026-1.024zM283.481 147.169H272.65c-.567 0-1.026.458-1.026 1.024v3.397c0 .566.459 1.024 1.026 1.024h10.831c.566 0 1.026-.458 1.026-1.024v-3.397c0-.566-.46-1.024-1.026-1.024zM299.572 147.169h-10.831c-.567 0-1.026.458-1.026 1.024v3.397c0 .566.459 1.024 1.026 1.024h10.831c.566 0 1.026-.458 1.026-1.024v-3.397c0-.566-.46-1.024-1.026-1.024z"
                ></path>
                <path
                    fill="url(#paint9_linear_0_6484)"
                    d="M315.184 147.169h-10.831c-.567 0-1.026.458-1.026 1.024v3.397c0 .566.459 1.024 1.026 1.024h10.831c.566 0 1.026-.458 1.026-1.024v-3.397c0-.566-.46-1.024-1.026-1.024z"
                ></path>
                <path
                    fill="#91B3FA"
                    d="M305.394 369.183H136.023c-.62 0-1.118-.503-1.118-1.117 0-.618.503-1.116 2.85-1.116h169.371c-1.113 0-.61.503-.61 1.116 0 .619-.503 1.117-1.117 1.117h-.005z"
                ></path>
                <path
                    fill="url(#paint10_linear_0_6484)"
                    d="M266.953 319.709c25.544-25.504 25.544-66.854 0-92.358-25.544-25.505-66.96-25.505-92.504 0-25.544 25.504-25.544 66.854 0 92.358 25.544 25.504 66.96 25.504 92.504 0z"
                ></path>
                <path
                    fill="url(#paint11_linear_0_6484)"
                    d="M221.352 325.967c29.368 0 53.176-23.771 53.176-53.093 0-29.322-23.808-53.092-53.176-53.092-29.368 0-53.176 23.77-53.176 53.092s23.808 53.093 53.176 53.093z"
                ></path>
                <path
                    fill="url(#paint12_linear_0_6484)"
                    d="M221.352 322.903c27.674 0 50.108-22.399 50.108-50.029 0-27.63-22.434-50.029-50.108-50.029-27.674 0-50.108 22.399-50.108 50.029 0 27.63 22.434 50.029 50.108 50.029z"
                ></path>
                <path
                    fill="url(#paint13_linear_0_6484)"
                    d="M240.772 231.233c-3.992-2.251-9.088-1.768-12.301 1.498-5.111 5.189-10.613 14.365-4.656 27.087 8.968 19.154 7.206 49.817-11.377 57.944 0 0 45.031 5.141 53.713-38.172 5.657-28.227-15.433-42.742-25.379-48.357z"
                ></path>
                <path
                    fill="#BDD0FB"
                    d="M213.158 234.804l-.788.039c-.494.058-1.244.145-2.188.434-.939.29-2.057.769-3.291 1.498-1.224.74-2.555 1.725-3.949 2.962-.672.609-1.427 1.3-2.153 2.02-.358.362-.731.734-1.104 1.116-.363.396-.735.797-1.117 1.213a54.58 54.58 0 00-4.511 5.658c-2.923 4.242-5.647 9.485-7.104 15.626-.165.769-.373 1.537-.484 2.334-.068.396-.136.792-.203 1.194l-.025.149c-.009.053 0 .015-.004.049l-.01.077-.034.309-.073.623c-.043.416-.101.841-.135 1.252-.024.406-.044.812-.068 1.222-.068.812-.029 1.663-.039 2.503.049 3.378.591 6.866 1.622 10.297.111.435.271.855.421 1.28.155.426.295.856.459 1.276.18.416.354.836.533 1.256.092.208.174.421.271.628l.305.614c.203.411.411.822.619 1.232.228.401.46.802.692 1.203l.349.604.387.58c.261.387.518.773.779 1.165.581.729 1.113 1.517 1.762 2.203.314.353.619.72.948 1.058.339.334.678.667 1.021 1l.257.252.063.062c.024.025 0 0 .043.039l.14.121.567.488.566.483.561.43c.373.29.746.58 1.157.846.402.27.794.56 1.215.802 6.591 4.155 15.074 5.808 23.142 4.242 8.087-1.541 15.685-6.093 21.11-12.485 2.676-3.18 4.824-6.871 6.059-10.814 1.238-3.938 1.519-8.147.571-12.094-.934-3.929-3.015-7.567-5.779-10.452-2.773-2.899-6.204-5.044-9.969-6.165-3.692-1.116-7.666-1.29-11.373-.643-3.716.643-7.225 2.039-10.211 4.04-2.986 1.995-5.473 4.58-7.09 7.518-.803 1.469-1.398 3.015-1.708 4.6-.324 1.561-.334 3.165-.136 4.697.421 3.058 1.854 5.861 4.012 7.649 2.139 1.821 4.912 2.512 7.424 2.435 5.062-.155 9.287-3.368 10.085-6.886.378-1.71-.062-3.421-.938-4.45-.886-1.077-2.106-1.367-3.044-1.333-.949.038-1.617.401-1.985.695a2.75 2.75 0 00-.387.377c-.077.092-.121.14-.121.14l-.019.025a.238.238 0 11-.368-.305s.044-.058.136-.169c.082-.116.237-.266.445-.454.426-.353 1.19-.788 2.274-.855a4.56 4.56 0 011.772.251c.159.048.309.13.469.198.155.082.329.179.47.275l.208.15c.096.068.145.126.222.189.145.12.271.265.407.41 1.031 1.189 1.568 3.044 1.171 5.03-.397 1.948-1.771 3.832-3.668 5.209-1.897 1.377-4.366 2.329-7.09 2.45a12.817 12.817 0 01-4.172-.488c-.353-.087-.692-.237-1.04-.353-.344-.14-.678-.3-1.021-.459-.33-.193-.692-.377-.993-.58l-.45-.309c-.082-.063-.13-.087-.246-.174l-.223-.184a12.018 12.018 0 01-2.991-3.638 14.498 14.498 0 01-1.548-4.663c-.242-1.657-.262-3.396.067-5.126.31-1.716.925-3.407 1.772-5.001 1.713-3.18 4.331-5.948 7.467-8.089 3.141-2.15 6.833-3.662 10.763-4.377 3.939-.72 8.111-.595 12.166.589 8.024 2.295 14.959 9.166 17.108 17.786 1.088 4.291.779 8.905-.542 13.128-1.322 4.247-3.572 8.142-6.417 11.544-5.687 6.735-13.667 11.572-22.257 13.239-8.595 1.691-17.625-.029-24.71-4.46-.455-.261-.876-.57-1.307-.86-.436-.28-.852-.604-1.273-.928l-.629-.483-.571-.488-.566-.483-.141-.121s-.077-.068-.091-.082l-.068-.068-.276-.27c-.368-.358-.736-.715-1.099-1.073-.358-.367-.682-.759-1.026-1.136-.701-.739-1.272-1.575-1.897-2.362a35.666 35.666 0 01-5.12-10.505c-1.074-3.648-1.645-7.334-1.655-10.91.019-.894-.005-1.773.078-2.667.029-.445.062-.884.091-1.324.039-.435.102-.841.15-1.261l.078-.624.039-.309.009-.077.015-.106.029-.16.232-1.251c.136-.836.363-1.638.547-2.445.803-3.204 1.979-6.156 3.315-8.838a49.104 49.104 0 014.433-7.233 55.702 55.702 0 014.825-5.663c.406-.406.798-.807 1.2-1.189.407-.376.803-.744 1.195-1.101a73.336 73.336 0 012.275-1.947c1.481-1.204 2.909-2.165 4.22-2.88 1.321-.706 2.526-1.155 3.538-1.397a12.106 12.106 0 012.352-.323c.522.004.793.009.793.009.136 0 .242.111.237.247 0 .13-.106.232-.232.236l.019.015z"
                ></path>
                <path
                    fill="url(#paint14_linear_0_6484)"
                    d="M368.064 210.012c2.052-5.451 2.943-11.935 1.588-19.497 8.29-1.44 16.028-4.392 22.818-9.093.808 11.635-2.289 24.487-13.018 37.234-5.212 6.189-12.22 12.35-21.458 18.337l-2.72 5.798-8.174-10.166s15.147-7.176 20.964-22.613z"
                ></path>
                <path
                    fill="url(#paint15_linear_0_6484)"
                    d="M253.065 159.374c8.382 1.464 15.713.372 22.198-2.03.17 1.435.412 2.885.75 4.334 1.418 6.364 3.369 12.525 6.103 18.207-12.559 1.855-23.897-1.783-32.352-6.122-.116-5.885 1.491-10.785 3.305-14.389h-.004z"
                ></path>
                <path
                    fill="#91B3FA"
                    d="M275.263 157.344c10.889-4.029 19.363-11.751 26.327-17.22 14.663-11.524 25.794-5.572 25.794-5.572l-15.98 30.171c-9.979 9.388-19.972 13.79-29.293 15.167-2.734-5.683-4.685-11.843-6.102-18.207a40.755 40.755 0 01-.751-4.334l.005-.005z"
                ></path>
                <path
                    fill="url(#paint16_linear_0_6484)"
                    d="M221.671 144.854l7.39 4.305c8.851 5.823 16.807 8.958 24.004 10.215-1.81 3.604-3.422 8.499-3.306 14.389-9.374-4.813-15.205-10.49-15.205-10.49-16.721-10.775-12.883-18.419-12.883-18.419z"
                ></path>
                <path
                    fill="url(#paint17_linear_0_6484)"
                    d="M305.805 355.267a39.61 39.61 0 00-.368-1.701l-60.309-252.827-25.814 4.972L257.57 362.79c.087.575.184 1.145.295 1.715l1.665 8.601c2.851 14.756 13.246 25.164 23.21 23.241l11.847-2.28c9.965-1.919 15.733-15.438 12.878-30.2l-1.665-8.6h.005zm-20.21 24.058c-6.61 1.275-13.715-6.702-15.858-17.811-2.149-11.108 1.471-21.149 8.081-22.424 6.611-1.276 13.715 6.702 15.859 17.81 2.149 11.108-1.471 21.149-8.082 22.425z"
                ></path>
                <path
                    fill="url(#paint18_linear_0_6484)"
                    d="M254.579 1.604c-6.615-3.89-14.731 1.972-13.274 9.5l9.645 49.898a11.666 11.666 0 01-2.715 9.934l-12.302 13.897a11.692 11.692 0 01-13.996 2.696l-16.599-8.33a11.666 11.666 0 01-6.224-8.21l-9.645-49.898c-1.456-7.528-11.174-9.954-15.863-3.885-11.218 14.52-16.367 33.94-12.53 53.793 6.935 35.886 39.732 55.17 74.305 48.507 34.573-6.663 57.827-36.746 50.887-72.632-3.838-19.854-15.854-35.964-31.679-45.275l-.01.005z"
                ></path>
                <path
                    fill="url(#paint19_linear_0_6484)"
                    d="M249.866 2.513c-6.616-3.89-14.732 1.971-13.275 9.499l9.645 49.899a11.647 11.647 0 01-2.715 9.934L231.219 85.74a11.69 11.69 0 01-13.995 2.696l-16.6-8.33a11.665 11.665 0 01-6.223-8.209L184.756 22c-1.457-7.529-11.174-9.954-15.864-3.885-11.218 14.52-16.367 33.939-12.529 53.793 6.935 35.886 39.732 55.17 74.305 48.507 34.573-6.664 57.826-36.747 50.886-72.633-3.837-19.854-15.854-35.963-31.679-45.274l-.009.005z"
                ></path>
                <path
                    fill="url(#paint20_linear_0_6484)"
                    d="M302.045 355.992a42.517 42.517 0 00-.368-1.701l-60.305-252.827-25.813 4.972 38.256 257.079c.087.575.184 1.145.295 1.715l1.665 8.601c2.85 14.756 13.245 25.164 23.21 23.241l11.847-2.281c9.964-1.918 15.733-15.437 12.877-30.199l-1.664-8.6zm-20.21 24.057c-6.611 1.276-13.715-6.701-15.859-17.81-2.148-11.108 1.471-21.149 8.082-22.424 6.611-1.276 13.715 6.701 15.859 17.81 2.149 11.108-1.471 21.149-8.082 22.424z"
                ></path>
                <path
                    fill="url(#paint21_linear_0_6484)"
                    d="M220.708 155.982a5.44 5.44 0 011.268-4.484c2.076-2.397 5.662-5.682 8.261-3.469 3.871 3.295-.373 14.572-.373 14.572l-4.292 6.548-.063 4.179c-2.323-2.715-3.712-9.398-4.806-17.346h.005z"
                ></path>
                <path
                    fill="url(#paint22_linear_0_6484)"
                    d="M319.718 398.985c0-.178.015-.357.063-.541 2.914-10.673 16.484-17.095 16.484-17.095l5.318.517c2.884 9.509 2.381 15.298 1.839 17.868-.014.073-.039.14-.058.208-4.404.309-13.454.396-23.65-.957h.004z"
                ></path>
                <path
                    fill="url(#paint23_linear_0_6484)"
                    d="M343.369 399.947c-.252.86-.905 1.517-1.723 1.672-6.277 1.193-16.193-.049-20.355-.672-.919-.135-1.573-1-1.573-1.962 10.197 1.353 19.247 1.266 23.651.957v.005z"
                ></path>
                <path
                    fill="url(#paint24_linear_0_6484)"
                    d="M343.877 373.985l-2.463 10.804c-.179.793-.804 1.377-1.544 1.431-.91.067-2.202.091-3.494-.121-1.162-.193-1.95-1.387-1.718-2.653l1.752-9.601 7.472.14h-.005z"
                ></path>
                <path
                    fill="url(#paint25_linear_0_6484)"
                    d="M296.634 398.956c5.89-.053 8.944-.686 10.531-1.299a38.085 38.085 0 01-.053 1.792c-.034.657-.533 1.174-1.133 1.16l-32.303-.817c-1.031-.024-1.612-1.232-1.147-2.164 4.23.43 15.002 1.415 24.105 1.333v-.005z"
                ></path>
                <path
                    fill="url(#paint26_linear_0_6484)"
                    d="M272.534 397.623c.038-.082.077-.165.13-.242 2.928-3.928 10.347-11.717 24.769-14.882l6.891-.087s2.967 5.383 2.836 15.245c-1.587.613-4.641 1.246-10.531 1.299-9.103.083-19.875-.903-24.105-1.333h.01z"
                ></path>
                <path
                    fill="url(#paint27_linear_0_6484)"
                    d="M305.8 372.014c-.087.512-1.176 8.287-1.602 11.302-.101.715-.634 1.261-1.292 1.328-1.176.116-3.078.208-4.728-.159-.89-.203-1.524-1.073-1.505-2.073l.232-12.229 8.895 1.836v-.005z"
                ></path>
                <path
                    fill="url(#paint28_linear_0_6484)"
                    d="M314.647 225.604s-19.15 79.368-20.35 158.712c-.02 1.445 11.058 2.72 11.314 1.391 2.59-13.596 19.649-102.159 27.498-114.49 0 0-.179 78.053-2.449 113.529-.058.884 9.994 3.774 12.094 1.522 0 0 14.165-86.384 14.746-140.592.029-2.793-5.019-20.067-5.019-20.067h-37.834v-.005z"
                ></path>
                <path
                    fill="url(#paint29_linear_0_6484)"
                    d="M300.477 141.172c-.31 3.078 1.185-1.517 0 0z"
                ></path>
                <path
                    fill="#91B3FA"
                    d="M300.477 141.172c.029-.285.072-.638.135-1.068 20.95-14.5 51.927-6.378 63.939-4.638a16.07 16.07 0 0110.056 5.638c6.117 7.345 16.624 22.391 17.863 40.317-6.79 4.702-14.523 7.654-22.818 9.094-.692-3.87-1.965-8.021-3.973-12.457a31.612 31.612 0 01-.847 3.04c-9.026 26.768-13.73 42.056-13.807 47.221-.01.701-41.334-1.009-34.017-1.222 3.059-.087-14.247-61.036-23.287-71.855-.537-.642 7.941-15.587 6.761-14.07h-.005z"
                ></path>
                <path
                    fill="url(#paint30_linear_0_6484)"
                    d="M345.595 113.462l1.742 22.072s-12.486 3.498-21.39-3.03l6.727-19.902 12.921.864v-.004z"
                ></path>
                <path
                    fill="url(#paint31_linear_0_6484)"
                    d="M331.667 88.08c-.305.275-13.071 24.178-13.071 24.178l13.826 6.987 15.472-20.859s-11.136-14.911-16.227-10.306z"
                ></path>
                <path
                    fill="url(#paint32_linear_0_6484)"
                    d="M336.313 93.197c3.102.454 4.743 3.875 5.396 5.658.237.647.16 1.362-.203 1.947l-7.177 11.451a2.283 2.283 0 01-.392.469c-.842.754-3.722 2.938-5.851-.15-1.82-2.633-3.528-5.03-5.386-6.039-1.085-.59-2.444-.16-3.02.932-1.191 2.247-3.499 6.832-4.975 11.191a2.202 2.202 0 001.239 2.734c2.802 1.199 8.348 3.368 13.289 4.146a2.216 2.216 0 002.119-.855c2.188-2.875 8.349-10.91 10.439-12.911 1.941-1.86 5.445-1.077 7.017-.594a2.25 2.25 0 001.781-.198c1.626-.938 4.477-3.291 1.989-7.417-.619-1.024-.266-2.368.746-3.01 1.814-1.145 3.803-3.32 2.018-6.939-2.26-4.57-8.658-4.14-12.249-7.504-1.771-1.657-3.509-3.508-5.812-4.286-.494-.169-1.012-.28-1.529-.27-2.26.043-5.682 3.764-5.837 6.01-.218 3.209 3.702 5.238 6.403 5.635h-.005z"
                ></path>
                <path
                    fill="url(#paint33_linear_0_6484)"
                    d="M339.091 115.969s2.826-7.77 6.247-7.417c3.422.353 6.055 3.813 1.733 7.562-5.372 4.668-7.98-.145-7.98-.145z"
                ></path>
                <path
                    fill="#91B3FA"
                    d="M366.85 176.063c4.747-12.254 3.392-27.189 3.378-27.339l-1.249.121c.015.145 1.341 14.79-3.3 26.769l1.171.449z"
                ></path>
                <path
                    fill="url(#paint34_linear_0_6484)"
                    d="M333.748 269.617a.626.626 0 00.615-.459c1.476-5.281 11.905-10.915 12.011-10.973a.624.624 0 10-.59-1.101c-.45.241-11.005 5.948-12.627 11.736a.63.63 0 00.596.797h-.005z"
                ></path>
                <path
                    fill="url(#paint35_linear_0_6484)"
                    d="M363.685 186.862c.068-.348 0-.71-.199-1.005l-15.418-23.193a.6.6 0 00-.499-.266h-28.228c-.465 0-.891.247-1.128.643l-13.415 22.666c-.232.392-.314.856-.232 1.305 5.309 16.1 10.448 31.948 10.081 39.655 9.621 7.504 26.549 5.938 38.101 2.483.595-10.059 5.551-25.893 10.937-42.293v.005z"
                ></path>
                <path
                    fill="url(#paint36_linear_0_6484)"
                    d="M358.255 134.649l-10.361 29.73h-6.238l9.214-30.962a.616.616 0 01.711-.425l6.49 1.338a.241.241 0 01.179.319h.005z"
                ></path>
                <path
                    fill="url(#paint37_linear_0_6484)"
                    d="M322.758 132.562l2.545 31.001-5.754.705-4.897-30.909a.39.39 0 01.353-.449l7.37-.672a.354.354 0 01.387.324h-.004z"
                ></path>
                <path
                    fill="url(#paint38_linear_0_6484)"
                    d="M323.769 89.612c12.302-23.203 44.194-2.126 29.351 17.423-11.034-7.325-23.505-18.216-29.351-17.423z"
                ></path>
                <path
                    fill="url(#paint39_linear_0_6484)"
                    d="M324.572 87.109c-24.874-1.266-4.399 7.943 18.255 12.857-5.638-5.977-11.276-10.432-18.255-12.857z"
                ></path>
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_0_6484"
                    x1="101.745"
                    x2="250.03"
                    y1="144.642"
                    y2="144.642"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint1_linear_0_6484"
                    x1="380.628"
                    x2="336.183"
                    y1="-97.082"
                    y2="-46.761"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint2_linear_0_6484"
                    x1="160.176"
                    x2="219.07"
                    y1="34.775"
                    y2="-82.23"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint3_linear_0_6484"
                    x1="-2425.57"
                    x2="-2542.61"
                    y1="-1194.59"
                    y2="-1253.68"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint4_linear_0_6484"
                    x1="-777.342"
                    x2="-836.235"
                    y1="1823.72"
                    y2="1940.73"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint5_linear_0_6484"
                    x1="15.017"
                    x2="142.212"
                    y1="222.845"
                    y2="222.845"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint6_linear_0_6484"
                    x1="111.704"
                    x2="333.738"
                    y1="265.143"
                    y2="265.143"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint7_linear_0_6484"
                    x1="123.198"
                    x2="171.549"
                    y1="160.36"
                    y2="160.36"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint8_linear_0_6484"
                    x1="256.012"
                    x2="316.205"
                    y1="163.732"
                    y2="163.732"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint9_linear_0_6484"
                    x1="303.327"
                    x2="316.205"
                    y1="149.894"
                    y2="149.894"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9CFFFB"></stop>
                    <stop offset="1" stopColor="#9BFFFA"></stop>
                </linearGradient>
                <linearGradient
                    id="paint10_linear_0_6484"
                    x1="155.295"
                    x2="286.11"
                    y1="273.527"
                    y2="273.527"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#DAE3FE"></stop>
                    <stop offset="1" stopColor="#E9EFFD"></stop>
                </linearGradient>
                <linearGradient
                    id="paint11_linear_0_6484"
                    x1="287.415"
                    x2="183.182"
                    y1="234.992"
                    y2="294.952"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint12_linear_0_6484"
                    x1="171.244"
                    x2="271.46"
                    y1="272.874"
                    y2="272.874"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint13_linear_0_6484"
                    x1="212.525"
                    x2="338.667"
                    y1="282.828"
                    y2="224.075"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint14_linear_0_6484"
                    x1="360.312"
                    x2="372.768"
                    y1="114.404"
                    y2="236.538"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint15_linear_0_6484"
                    x1="264.491"
                    x2="277.999"
                    y1="162.664"
                    y2="295.143"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint16_linear_0_6484"
                    x1="198.82"
                    x2="301.649"
                    y1="103.764"
                    y2="240.783"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint17_linear_0_6484"
                    x1="71.034"
                    x2="286.902"
                    y1="252.392"
                    y2="248.175"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint18_linear_0_6484"
                    x1="145.106"
                    x2="276.486"
                    y1="182.924"
                    y2="-27.288"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint19_linear_0_6484"
                    x1="214.78"
                    x2="243.726"
                    y1="5.726"
                    y2="382.598"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint20_linear_0_6484"
                    x1="241.9"
                    x2="270.846"
                    y1="3.643"
                    y2="380.515"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint21_linear_0_6484"
                    x1="261.621"
                    x2="311.929"
                    y1="146.168"
                    y2="125.82"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint22_linear_0_6484"
                    x1="319.718"
                    x2="343.843"
                    y1="390.742"
                    y2="390.742"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint23_linear_0_6484"
                    x1="332.763"
                    x2="331.972"
                    y1="337.887"
                    y2="379.917"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint24_linear_0_6484"
                    x1="337.82"
                    x2="341.644"
                    y1="363.335"
                    y2="403.457"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint25_linear_0_6484"
                    x1="290.977"
                    x2="290.186"
                    y1="337.101"
                    y2="379.13"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint26_linear_0_6484"
                    x1="272.534"
                    x2="307.17"
                    y1="390.689"
                    y2="390.689"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint27_linear_0_6484"
                    x1="300.312"
                    x2="304.141"
                    y1="366.915"
                    y2="407.037"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint28_linear_0_6484"
                    x1="-1672.49"
                    x2="-1472.04"
                    y1="-2019"
                    y2="-1784.87"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint29_linear_0_6484"
                    x1="300.636"
                    x2="300.936"
                    y1="140.993"
                    y2="143.907"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FDF53F"></stop>
                    <stop offset="0.66" stopColor="#E57A58"></stop>
                    <stop offset="1" stopColor="#D93C65"></stop>
                </linearGradient>
                <linearGradient
                    id="paint30_linear_0_6484"
                    x1="332.496"
                    x2="348.558"
                    y1="107.222"
                    y2="183.249"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint31_linear_0_6484"
                    x1="333.332"
                    x2="333.814"
                    y1="94.535"
                    y2="34.62"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint32_linear_0_6484"
                    x1="314.584"
                    x2="356.039"
                    y1="103.556"
                    y2="103.556"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint33_linear_0_6484"
                    x1="342.31"
                    x2="344.511"
                    y1="148.139"
                    y2="112.49"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint34_linear_0_6484"
                    x1="216.923"
                    x2="327.348"
                    y1="107.141"
                    y2="247.796"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint35_linear_0_6484"
                    x1="-1610.58"
                    x2="-1405.75"
                    y1="-1982.01"
                    y2="-1751.7"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint36_linear_0_6484"
                    x1="337.019"
                    x2="429.351"
                    y1="106.156"
                    y2="416.025"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint37_linear_0_6484"
                    x1="310.857"
                    x2="403.193"
                    y1="113.954"
                    y2="423.818"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint38_linear_0_6484"
                    x1="360.801"
                    x2="265.556"
                    y1="73.077"
                    y2="178.618"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint39_linear_0_6484"
                    x1="312.99"
                    x2="343.661"
                    y1="89.977"
                    y2="95.283"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <clipPath id="clip0_0_6484">
                    <path fill="#fff" d="M0 0H400V402.116H0z"></path>
                </clipPath>
            </defs>
        </svg>
    );
}

export default MainImg;
